import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageContainer from "../../layouts/PageContainer";
import Button from "@material-ui/core/Button";
import {
  TextField,
} from "@material-ui/core";
import { Grid } from "@mui/material";
import { helpers } from "../../helper/helper";
import { Card, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    // margin: theme.spacing(2),
    // width: '250px', // Adjust the width as needed
    padding: "15px",
    background: "#F85476",
    textAlign: "center",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px",
    cursor: "pointer"
  },
}));

const ShortCategory = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    getListOfShortCategory();
  }, []);

  const getListOfShortCategory = async () => {
    setLoading(true);
    const url = `reel/category/list/admin/v1?search=`;
    const result = await helpers.apiCall("GET", url);
    setList(result && result.data && result.data.result ? result.data.result.response : []);
    setLoading(false);
  };

  const handleSearch = async () => {
    setLoading(true);
    const url = `reel/category/list/admin/v1?search=${search}`;
    const result = await helpers.apiCall("GET", url);
    setList(result && result.data && result.data.result ? result.data.result.response : []);
    setLoading(false);
  };

  return (
    <>
      <PageContainer pageheading="Shorts Categories"></PageContainer>
      <div className="row">
        <div className="col-12">
          <div className="row m-3">
            <div className="col-6">
              <Grid item xs={12} sm={12} md={12}>
                <div className="">
                  <div className="input-group serch-sec">
                    <TextField
                      size="small"
                      variant="outlined"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control rounded"
                      placeholder="Search Short Categoryies"
                      aria-label="Search"
                      aria-describedby="search-addon"
                    />
                    &nbsp;
                    <Button
                      style={{ height: "38px" }}
                      variant="contained"
                      color="primary"
                      onClick={handleSearch}
                    >
                      Go
                    </Button>
                  </div>
                </div>
              </Grid>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-md-6 d-flex">
                  <p className="my-auto" style={{ fontWeight: "500", fontSize: "16px" }}>Total Categories - {list?.length} items</p>
                </div>
              </div>
            </div>
          </div>
          {
            loading ?
              <div style={{ display: "flex", width: "100%", height: "60vh", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" style={{ color: "#F85476" }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              :
              <>
                <div className="row ml-3 mr-3">
                  {
                    list && list?.length > 0 ?
                      <>
                        {
                          list?.map(category => (
                            <div className="col-3 mt-3" key={category._id}>
                              <Card className={classes.card} onClick={e => history.push('/dashboard/shorts', { category: category?._id })}>
                                {category?.name}
                              </Card>
                            </div>
                          ))
                        }
                      </>
                      :
                      <>
                        <h4 className="text-center ml-3" style={{ color: "#F85476" }}>Not Found</h4>
                      </>
                  }
                </div>
              </>
          }
        </div>
      </div>
    </>
  )
};

export default ShortCategory;